module.exports = __webpack_public_path__ + "ea1d86282009d742d09e500a46c52eaf.MP3";